import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getImageUrl } from '@culture/common-helpers/cultureUtils';

import LazyLoadImage from 'components/LazyLoad/Image';
import Icon from 'components/Icon';

import { FilePropType } from 'propTypes/common';

import { ImageFormatContext } from 'contexts/ImageFormatContext';

import styles from './styles.module.scss';

const UpturnCard = ({
	card,
	hasRoundImageOtherSide,
	isActive,
	isReverseSideStyle,
	position
}) => {
	const imageFormat = useContext(ImageFormatContext);
	const { file, imageType, text, textAligment, title } = card;

	const sizeImage =
		imageType === 'round' ? { width: 200, height: 200 } : { width: 884 };

	const imageSrc = getImageUrl(file, {
		format: imageFormat,
		params: {
			crop: 'fill',
			gravity: 'center',
			...sizeImage
		}
	});

	const ratioImage =
		imageType === 'cover' && imageSrc ? (file.height / file.width) * 100 : null;

	const showTextContent = imageType !== 'cover' && (text || title);

	const blockStyles = {
		paddingBottom: position === 'front' && ratioImage ? `${ratioImage}%` : null,
		background:
			imageType === 'cover' && file?.averageColor
				? `#${file.averageColor}`
				: '#f1f2f3'
	};

	return (
		<div
			className={cx(
				styles.UpturnCardBlock,
				styles[`UpturnCardBlock_${position}`],
				styles[`UpturnCardBlock_imageType_${imageType}`],
				{
					[styles.UpturnCardBlock_textRight]:
						imageType === 'round' && textAligment === 'right',
					[styles.UpturnCardBlock_hasRoundImageOtherSide]: hasRoundImageOtherSide,
					[styles.UpturnCardBlock_reverseCard]: isReverseSideStyle,
					[styles.UpturnCardBlock_active]: isActive
				}
			)}
			style={blockStyles}
		>
			{showTextContent && (
				<div className={styles.UpturnCardBlock__Content}>
					{title && (
						<div className={styles.UpturnCardBlock__Title}>{title}</div>
					)}
					{text && <div className={styles.UpturnCardBlock__Text}>{text}</div>}
				</div>
			)}
			<LazyLoadImage
				className={styles.UpturnCardBlock__WrapImage}
				imageSrc={imageSrc}
			>
				<img className={styles.UpturnCardBlock__Image} src={imageSrc} alt="" />
			</LazyLoadImage>
			<div className={styles.UpturnCardBlock__Figure}>
				<Icon icon="rotate" className={styles.UpturnCardBlock__Icon} />
			</div>
		</div>
	);
};

UpturnCard.propTypes = {
	card: PropTypes.shape({
		file: FilePropType,
		imageType: PropTypes.oneOf(['center', 'cover', 'round']),
		text: PropTypes.string,
		textAligment: PropTypes.oneOf(['right', 'left']),
		title: PropTypes.string
	}).isRequired,
	hasRoundImageOtherSide: PropTypes.bool,
	isActive: PropTypes.bool,
	isReverseSideStyle: PropTypes.bool,
	position: PropTypes.oneOf(['back', 'front']).isRequired
};

export default UpturnCard;
